import { useState } from "react";
import { createContext } from "react";
import axios from "axios";
import { useToast } from "@chakra-ui/react";

export const AuthContext = createContext();

export default function AuthContextProvider({ children }) {
  const [isAuth, setAuthStatus] = useState(false);
  const [token, setToken] = useState(null);
  const [registered, setRegistrationStatus] = useState(false);
  const [location, setLocation] = useState("");

  const toast = useToast();

  const loginUser = (userCredential) => {
    axios
      .post("https://poco-care-assignment.onrender.com/user/login", {
        email: userCredential.email,
        password: userCredential.password,
      })
      .then((res) => {
        // console.log(res);
        if(res.data === "Something went wrong in Login, please try again later")
        {
          // alert(res.data);
          // alert("Invalid email or password");
          toast({
            title: "Invalid email or password !",
            position: 'top-center',
            status: "warning",
            duration: 3000,
            isClosable: true,
          });
          return;
        }
        // alert("Logged In Successfully");
        toast({
          title: "Logged In Successfully !",
          position: 'top-center',
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setAuthStatus(true);
        // console.log(res.data.token);
        setToken(res.data.token);
        let loggedIn = localStorage.getItem("isLoggedIn");
        if (loggedIn === undefined) {
          localStorage.setItem("isLoggedIn", true);
        }
        localStorage.setItem("isLoggedIn", true);
      })
      .catch((err) => {
        // alert("invalid email or password");
        toast({
          title: "Wrong email or password !",
          position: 'top-center',
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        console.log(err);
      });
  };

  const registerUser = (userDetails) => {
    axios
      .post("https://poco-care-assignment.onrender.com/user/signup", {
        email: userDetails.email,
        password: userDetails.password,
      })
      .then((res) => {

        if (res.data === "User already exist") {
          // alert(res.data);
          // alert("User already exist");
          toast({
            title: `${res.data}`,
            position: 'top-center',
            status: "warning",
            duration: 3000,
            isClosable: true,
          });
          return;
        }

        // alert("registration successful");
        toast({
          title: "registration successful",
          position: 'top-center',
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setTimeout(() => {
          setRegistrationStatus(true);
        }, 2000);
        setTimeout(() => {
          setRegistrationStatus(false);
        }, 3000);
      })
      .catch((err) => {
        // alert("registration failed");
        toast({
          title: "registration failed",
          position: 'top-center',
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        console.log(err);
      });
  };

  const logOutUser = () => {
    setAuthStatus(false);
    setToken(null);
    localStorage.setItem("isLoggedIn", false);
  };

  const changeLocation = (newLocation) => {
    setLocation(newLocation);
  };
  
  return (
    <AuthContext.Provider
      value={{
        isAuth,
        token,
        loginUser,
        registered,
        registerUser,
        logOutUser,
        location,
        changeLocation,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
